import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBComponentVue from '@/components/SBComponentVue';

@Component({
    components: {},
})
export default class SBButtonClosed extends Mixins(SBComponentVue) {

    @Prop({
        type: String,
        default: "",
    })
    public color!: string;
}
